const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20breaking%20news%20with%20glowing%20red%20alerts%20on%20dark%20digital%20background%2C%20dramatic%20lighting%2C%20modern%20newsroom%20aesthetic%2C%20professional%20editorial%20style&width=800&height=500&seq=card-news-01&orientation=landscape',
    title: '某顶流男星深夜密会神秘女子，酒店共度8小时，粉丝集体破防',
    tag: '恋情曝光',
    time: '2小时前',
    views: '128万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20scene%20with%20flashing%20cameras%20and%20luxurious%20atmosphere%2C%20abstract%20artistic%20rendering%2C%20warm%20golden%20and%20crimson%20tones%2C%20editorial%20style&width=800&height=500&seq=card-news-02&orientation=landscape',
    title: '知名综艺节目录制现场突发状况，导演当场发飙离场',
    tag: '综艺翻车',
    time: '4小时前',
    views: '96万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20live%20streaming%20studio%20with%20dramatic%20red%20lighting%2C%20modern%20influencer%20setup%2C%20abstract%20digital%20art%20style%2C%20warm%20vibrant%20atmosphere&width=800&height=500&seq=card-news-03&orientation=landscape',
    title: '千万粉丝网红直播中意外曝光真实长相，美颜滤镜碎一地',
    tag: '网红黑料',
    time: '6小时前',
    views: '215万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20film%20set%20with%20dramatic%20lighting%20and%20cinematic%20atmosphere%2C%20warm%20spotlights%2C%20artistic%20abstract%20rendering%2C%20editorial%20quality&width=800&height=500&seq=card-news-04&orientation=landscape',
    title: '某S+大制作剧组内部矛盾升级，男女主疑似片场零交流',
    tag: '剧组路透',
    time: '8小时前',
    views: '87万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20stage%20with%20dramatic%20golden%20and%20crimson%20atmosphere%2C%20abstract%20artistic%20photography%20style%2C%20luxurious%20event%20lighting%2C%20editorial%20quality&width=800&height=500&seq=card-news-05&orientation=landscape',
    title: '年度颁奖典礼后台争执视频流出，两位一线女星当场互撕',
    tag: '吃瓜爆料',
    time: '10小时前',
    views: '342万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">精选爆料</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">编辑精选，不容错过的热门爆料内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{card.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 阅读</span>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cards.slice(3).map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-[200px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex flex-col justify-center min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{card.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{card.views} 阅读</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}